import { Pipe, PipeTransform } from '@angular/core';
import { IMainMenuDropdown } from '@app-store';
import { IMenuItemLink } from '@utils/interfaces/menu-item-link.model';

@Pipe({
  name: 'displayWithAuth'
})
export class DisplayWithAuthPipe implements PipeTransform {
  transform(menuItem: IMainMenuDropdown & IMenuItemLink, authInfor: any): boolean {
    if (menuItem === undefined) {
      return false;
    }

    if ((menuItem?.link?.label?.toLowerCase() === 'favs' || menuItem?.label?.toLowerCase() === 'favs') && !authInfor) {
      return false;
    }

    return true;
  }
}
